var __jsx = React.createElement;
import React from 'react';
import Markdown from 'markdown-to-jsx';
import { twMerge } from 'tailwind-merge';
import SharedPopUp from '@componentsShared/SharedPopUp/SharedPopUp';
import BottomSheet from '@componentsShared/BottomSheet/BottomSheet';
import useIsMobile from '@hooks/useIsMobile';
var WarrantyInfoContent = function WarrantyInfoContent(_ref) {
  var info = _ref.info,
    onClose = _ref.onClose,
    _ref$showClose = _ref.showClose,
    showClose = _ref$showClose === void 0 ? true : _ref$showClose,
    _ref$closeSide = _ref.closeSide,
    closeSide = _ref$closeSide === void 0 ? 'left' : _ref$closeSide,
    _ref$narrowText = _ref.narrowText,
    narrowText = _ref$narrowText === void 0 ? false : _ref$narrowText,
    _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? 'popup' : _ref$variant;
  return /*#__PURE__*/React.createElement("div", {
    className: twMerge("relative flex flex-col items-center text-center px-6 py-8 gap-3 pb-16", variant === 'sheet' && "pt-3 pb-10")
  }, variant === 'sheet' && /*#__PURE__*/React.createElement("div", {
    style: {
      width: '36px',
      height: '5px',
      flexShrink: 0,
      borderRadius: '100px',
      background: '#CCC',
      mixBlendMode: 'plus-darker'
    },
    className: "mb-4"
  }), showClose && /*#__PURE__*/React.createElement("button", {
    type: "button",
    onClick: function onClick(e) {
      e.preventDefault();
      e.stopPropagation();
      onClose();
    },
    "aria-label": "close",
    className: twMerge("absolute leading-none z-10", variant === 'sheet' ? "top-5" : "top-3 text-xl", closeSide === 'right' ? "right-4" : "left-3"),
    style: {
      color: variant === 'sheet' ? '#00143C' : '#0D0DB5',
      fontSize: variant === 'sheet' ? '30px' : undefined
    }
  }, "\xD7"), /*#__PURE__*/React.createElement("img", {
    src: info.icon,
    width: variant === 'sheet' ? 96 : 123,
    height: variant === 'sheet' ? 96 : 123,
    alt: "warranty-info",
    "aria-label": "warranty-info",
    className: variant === 'sheet' ? "mt-2" : undefined
  }), /*#__PURE__*/React.createElement("div", {
    className: twMerge("font-bold [&>strong]:font-bold", variant === 'sheet' ? "mb-6" : "mb-8"),
    style: {
      fontSize: '24px',
      color: variant === 'sheet' ? '#00143C' : '#000'
    }
  }, /*#__PURE__*/React.createElement(Markdown, null, info.title)), /*#__PURE__*/React.createElement("p", {
    className: twMerge("leading-6", narrowText && "w-[70%]"),
    style: variant === 'sheet' ? {
      fontSize: '16px',
      color: '#6C7A8D'
    } : {
      fontSize: '20px',
      color: '#000'
    }
  }, info.text), variant === 'sheet' && /*#__PURE__*/React.createElement("div", {
    style: {
      width: '127.203px',
      height: '4.746px',
      borderRadius: '94.928px',
      background: '#00143C',
      position: 'fixed',
      left: '50%',
      transform: 'translateX(-50%)',
      bottom: 'calc(12px + env(safe-area-inset-bottom))',
      zIndex: 20
    }
  }));
};
var WarrantyInfoModal = function WarrantyInfoModal(_ref2) {
  var show = _ref2.show,
    onClose = _ref2.onClose,
    info = _ref2.info;
  var isMobile = useIsMobile();
  if (!info) return null;
  if (isMobile) {
    return /*#__PURE__*/React.createElement(BottomSheet, {
      open: show,
      onOpen: function onOpen() {},
      onClose: onClose,
      hideTitleBar: true,
      haveClose: false,
      zeroHeightHead: true,
      maxHeight: "40vh",
      screens: [{
        key: 'warranty-info',
        component: /*#__PURE__*/React.createElement(WarrantyInfoContent, {
          info: info,
          onClose: onClose,
          closeSide: "right",
          variant: "sheet"
        })
      }]
    });
  }
  return /*#__PURE__*/React.createElement(SharedPopUp, {
    show: show,
    onClose: onClose,
    widthVariant: "wide",
    maxWidth: "820px",
    hideCloseBtn: true
  }, /*#__PURE__*/React.createElement(WarrantyInfoContent, {
    info: info,
    onClose: onClose,
    narrowText: true
  }));
};
export default WarrantyInfoModal;